<template>
  <div class="login-container">
    <div class="login-center">
      <el-form>
        <el-row>
          <div align='center'>
            <img src='../../statics/images/loginlogo.png' alt='' style='width: 33.4%;height: 19.2%; text-align:center;padding:10px 0px 0px 0px'>
          </div>
          <el-form-item align="center">
            <div style='padding:0px 0px 9px 0px'>
              <el-input class="login-input" size="small" :autofocus="true" :placeholder="userid" v-model="username" maxlength="16"></el-input>
            </div>
            <div style='padding:0px 0px 5px 0px'>
              <el-input class="login-input" size="small" :placeholder="paswd" type="password" v-model="password"></el-input>
            </div>
            <div align="center">
              <el-button class="login-button css-btn" @click.native="login" type="primary" :loading="isBtnLoading">{{btnText}}</el-button>
            </div>
          </el-form-item>
        </el-row>
      </el-form>
      <!-- passwordReset -->
      <div>
        <a class="passwordReset_button" style="text-decoration:underline;" @click="showpasswordResetDialog = true">{{$t('COMMON.LOGIN_BUTTON')}}</a>
        <PasswordReset :visible.sync="showpasswordResetDialog" v-if="showpasswordResetDialog" :show="showpasswordResetDialog" @closepasswordResetDialog="closepasswordResetDialog" @submitpasswordResetDialog="submitpasswordResetDialog"></PasswordReset>
        <el-row v-if="!showpasswordResetDialog" class="ver-text">
          {{$t('COMMON.LBL_VER')}}
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import utils from '@/common/utils.js'
import * as amsApi from "../api/login"
import i18n from '@/message/i18n.js'
import axios from 'axios';
import PasswordReset from '@/components/page/passwordReset.vue'
import css from "@/statics/css"
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  components: {
    "PasswordReset": PasswordReset
  },
  data() {
    return {
      username: '',
      password: '',
      isBtnLoading: false,
      showpasswordResetDialog: false,
    };
  },
  computed: {
    btnText() {
      if (this.isBtnLoading) return i18n.t('COMMON.LOGIN_LBL_LOGINING');
      return i18n.t('COMMON.LOGIN_LBL_LOGIN');
    },
    user() {
      return this.$store.state.user
    },
    userid() {
      return i18n.t('COMMON.LOGIN_LBL_USER');
    },
    paswd() {
      return i18n.t('COMMON.LOGIN_LBL_PASWD');
    }
  },
  methods: {
    login() {
      var vm = this;
      if (!vm.username) {
        vm.$message.error(i18n.t('COMMON.LOGIN_LBL_USERCD_CHECK'));
        return;
      }
      if (!vm.password) {
        vm.$message.error(i18n.t('COMMON.LOGIN_LBL_PASSWORD_CHECK'));
        return;
      }
      vm.isBtnLoading = true;
      // ユーザーチェック
      let loginParams = { userCd: vm.username, password: vm.password }
      amsApi.login_check(loginParams).then(res => {
        if (res.code == '200') {
          vm.$router.push({ path: url.routerUrl_Top })
        } else {
          vm.$message.error(i18n.t('COMMON.LOGIN_LBL_LOGINCHECK_ERROR'))
          return
        }
      }).catch(err => {
        vm.$message.error(i18n.t('COMMON.LOGIN_LBL_LOGINCHECK_ERROR'));
        vm.isBtnLoading = false;
      });
      vm.isBtnLoading = false;
    },

    // 关闭企业对话框的弹窗回调
    closepasswordResetDialog() {
      this.companyInputEdit = false
      this.showpasswordResetDialog = false
    },
    // 选择企业对话框弹窗回调
    submitpasswordResetDialog(row) {
      this.companyInputEdit = false
      this.companyInput = row.companyName
      this.companyDialogCd = row.companyCd
      this.showpasswordResetDialog = false
      this.storeInput = ''
      this.storeDialogCd = ''
    }, blurSearchFor1() {
      this.companyInputEdit = true
      this.showpasswordResetDialog = true;
    }
  },

  created() {
    // logout 保留k0003 select选择值  Add xuyang 20230731
    var k0003_businessTypeSelectKey = localStorage.getItem('k0003_businessTypeSelectKey');
    console.log('login-k0003_businessTypeSelectKey:' + k0003_businessTypeSelectKey);
    localStorage.clear()
    // logout 保留k0003 select选择值  Add xuyang 20230731
    localStorage.setItem('k0003_businessTypeSelectKey', k0003_businessTypeSelectKey);
    this.close_loading()
  }
};
</script>
<style scope>
.login-container {
  width: 100%;
  height: 96vh;
  background: url('../../statics/images/loginbac.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}
.login-center {
  width: 30%;
  height: 40%;
  min-width: 260px;
  min-height: 280px;
  background: white;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  box-shadow: 1px 2px 20px 2px #156264;
  border: solid 1px #999999;
}
.login-logo {
  width: 30%;
  height: 20%;
  text-align: center;
  src: url('../../statics/images/loginlogo.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}
.login-input .el-input__inner {
  width: 55%;
  height: 30px;
  /* box-shadow: 0px 3px 3px #c0c0c0 inset; */
  border: solid 1px #3cc6fa;
  line-height: 16px;
}
.login-button {
  width: 55%;
  height: 35px;
  padding: 0px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/* passwordReset LINK样式 */
.passwordReset_button {
  font-size: 12px;
  position: absolute;
  right: 5px;
  bottom: 20px;
  color: blue;
}
.ver-text {
  font-size: 12px;
  position: absolute;
  right: 5px;
  bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/login.vue